<div class="app-switcher">
    <div fxLayout="row wrap" [fxLayoutGap]="gapSize" [ngClass]="size">
        <div *ngFor="let modular of modularList" (click)="navigationModular(modular)"
            class="card-switcher artstuff-pointer card-size" fxLayout="column" fxLayoutAlign="center center"
            fxLayoutGap="12px" [ngClass]="{'active': modular.key == keyApp}">
            <div *ngIf="modular.key == keyApp" class="position-absolute align-top mt-12 align-right mr-12">
                <mat-icon class="mat-icon s-18 border-radius-100 artstuff-orange-bg fuse-white-fg">check</mat-icon>
            </div>
            <div>
                <img class="logo-modular" [src]="modular.logo">
            </div>
            <div class="text-bold title-text">
                {{'APP_SWITCHER.' + modular.title | translate }}
            </div>
        </div>
    </div>
</div>